import React from 'react';

import { useTranslation } from '@lyearn/i18n';

import RestrictedVisibilitySettingsModal from './BaseRestrictedVisibilitySettingsModal';
import { RestrictedVisibilitySettingsModalProps } from './types';
import { getGroupsTab, getUsersTab } from './utils';

export const GroupModal: React.FC<RestrictedVisibilitySettingsModalProps> = (props) => {
  const { t } = useTranslation();
  const {
    contextualGroupsConfig,
    classes,
    action,
    header,
    onChange,
    disabled,
    onClose,
    value,
    allowGroupCsvImport,
  } = props;

  return (
    <RestrictedVisibilitySettingsModal
      action={{
        discardText: t('Common:Cancel'),
        text: t('Group:Modal.AddGroups'),
        ...action,
      }}
      classes={classes}
      disabled={disabled}
      header={{
        title: t('Group:Modal.AddGroups'),
        description: t('Group:Modal.AddGroupsDescription'),
        ...header,
      }}
      tabs={[
        getGroupsTab({
          t,
          contextualGroupsConfig,
          allowCsvImport: allowGroupCsvImport,
        }),
      ]}
      value={value}
      onChange={onChange}
      onClose={onClose}
    />
  );
};

export const UsersAndGroupsModal: React.FC<RestrictedVisibilitySettingsModalProps> = (props) => {
  const { t } = useTranslation();
  const {
    contextualGroupsConfig,
    classes,
    action,
    value,
    onChange,
    disabled,
    onClose,
    header,
    allowGroupCsvImport,
  } = props;

  return (
    <RestrictedVisibilitySettingsModal
      action={{ discardText: t('Common:Cancel'), text: t('Group:Modal.AddPeople'), ...action }}
      classes={classes}
      disabled={disabled}
      header={{
        title: t('Group:Modal.AddPeople'),
        description: t('Group:Modal.AddPeopleDescription'),
        ...header,
      }}
      tabs={[
        getUsersTab({ t }),
        getGroupsTab({
          t,
          contextualGroupsConfig,
          allowCsvImport: allowGroupCsvImport,
        }),
      ]}
      value={value}
      onChange={onChange}
      onClose={onClose}
    />
  );
};
